import React from "react";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../components/reusable/Header";
import Footer from "../components/reusable/Footer";
import BusinessSignup from "../components/Signup/BusinessSignup";
// import AssistantSignup from "../components/Signup/AssistantSignup";
import SignupIcon from "../assets/icons/signup.svg";

function Signup() {
  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    checkType();
  }, []);
  const getType = () => {
    return params.type;
  };
  const checkType = () => {
    const signups = ["customer"]
    if (!signups.includes(getType())) {
      navigate("/error");
    }
  };
  return (
    <div id="signup" className="sys_bg_white2">
      <Header />
      <div className="my-20 flex justify-center">
        <div className="p-8 sys_bg_white rounded-lg border">
          <div className="flex items-center font-bold text-2xl mb-6">
            <div className="bg-black rounded-full p-3 bg-opacity-10 mr-4">
              <img src={SignupIcon} alt="Signup" />
            </div>
            <h1 className="capitalize sys_black">Signup - {getType()}</h1>
          </div>
          {getType() === "customer" && <BusinessSignup />}
          {/* {getType() === "assistant" && <AssistantSignup />} */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Signup;
